import styled from 'styled-components';
import tw from 'twin.macro';

export const SidebarContainer = styled.div`
  width: 440px;
  min-width: 440px;
`;
export const TitleContainer = styled.div`
  border-radius: 15px;

  .title {
    font-size: 18px;
  }

  .progress-bar {
    width: 79px;
    height: 79px;
    min-width: 79px;
    position: relative;

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 41px;
      height: 31px;
    }
  }
`;
export const ContentTitleContainer = styled.div`
  margin-bottom: 15px;
`;
export const LinkButton = styled.div.attrs({
  className: 'hover:underline cursor-pointer font-bold uppercase text-sm',
})`
  display: flex;
  align-items: center;
`;
export const Container = styled.div`
  @media only screen and (max-width: 639px) {
    max-width: 1440px;
    padding: 40px 30px;

    .complete-btn {
      min-width: 120px;
      width: 120px;
      padding: 7px 13px;
      font-size: 10px;
      font-weight: 500;
      height: 26px;
    }
  }
`;
export const Content = styled.div`
  background: white;
  border-radius: 20px;
  padding: 30px;
  position: relative;
  width: 100%;

  .lesson-list {
    overflow: auto;

    .selected {
      ${tw`bg-primary text-white rounded-lg`}

      svg > path {
        stroke: white;
      }
    }

    .lesson-title {
      width: calc(100% - 36px);
      font-size: 12px;
      font-weight: 500;
    }
    .check-circle {
      min-width: 16px;
      min-height: 16px;
    }
  }
`;
